// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3TBFh","footer":"ModalCreateQualiphyProcedure_footer__21LX2","additionData":"ModalCreateQualiphyProcedure_additionData__3wnvI"};